import { propClassName } from '@/styles/TextField';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { TextFieldCaptionComponent } from './TextField.Caption';
import { TextFieldGroupComponent } from './TextField.Group';
import { TextFieldIconComponent } from './TextField.Icon';
import { TextFieldInputComponent } from './TextField.Input';
import { TextFieldLabelComponent } from './TextField.Label';

export interface TextFieldProps extends ComponentProps<'div'> {
  colors?: ClassNameProp<'primary'>;
  size?: ClassNameProp<'default' | 'alternative'>;
  status?: 'default' | 'error';
  variant?: ClassNameProp<'default' | 'alternative'>;
}

const TextFieldComponent: Component<TextFieldProps> = ({
  children,
  className,
  colors,
  size,
  status,
  variant,
  ...props
}) => {
  const colorsClassName = propClassName('colors', colors, 'primary');
  const sizeClassName = propClassName('size', size, 'default');
  const variantClassName = propClassName('variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <div className={componentClassName} data-status={status} {...props}>
      {children}
    </div>
  );
};

export const TextField = Object.assign(TextFieldComponent, {
  Caption: TextFieldCaptionComponent,
  Group: TextFieldGroupComponent,
  Icon: TextFieldIconComponent,
  Input: TextFieldInputComponent,
  Label: TextFieldLabelComponent,
});
